import { Component, Input } from '@angular/core';

@Component({
  selector: 'atlas-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class BusinessNavChipComponent {
  @Input() text: string;
  @Input() isDefaultChip: boolean;
  @Input() isNavChip: boolean;
  @Input() isBetaChip: boolean;
}
